
import './App.css';
import Container from './components/Container';
import Form from './components/Form';
import FormFooter from './components/FormFooter';

function App() {
  return (
    <Container>
      <Form />
      <FormFooter />
    </Container>
  );
}

export default App;
